import _typeof from "@babel/runtime/helpers/typeof";
export var hydratedValueToString = function hydratedValueToString(value) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!value) {
    return null;
  }
  return Array.isArray(value) ? value.join(separator) : value;
};
function isURL(icon) {
  return typeof icon === 'string';
}
function isValidEmoji(icon) {
  return _typeof(icon) === 'object' && icon.value !== undefined && !!icon.value;
}
export var hydrateConfluenceIcon = function hydrateConfluenceIcon(confluenceContainerType, icons, fallbacks) {
  switch (confluenceContainerType) {
    case 'ConfluenceBlogPost':
      return hydrateIcon(icons, fallbacks, 'confluenceBlogIcon') || hydrateIcon(icons, fallbacks);
    case 'ConfluencePage':
      return hydrateIcon(icons, fallbacks, 'confluencePageIcon') || hydrateIcon(icons, fallbacks);
    default:
      return hydrateIcon(icons, fallbacks);
  }
};
export var hydrateIcon = function hydrateIcon(icons, fallbacks) {
  var fallbackKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'icon';
  if (Array.isArray(icons) && icons.length > 0) {
    var emojiIcons = icons.filter(isValidEmoji);
    if (emojiIcons.length > 0) {
      return {
        type: 'EMOJI',
        value: emojiIcons[0].value,
        // return the first emoji
        fallback: fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks[fallbackKey]
      };
    }
    var urlIcons = icons.filter(isURL);
    if (urlIcons.length > 0) {
      var hydratedIcons = hydratedValueToString(urlIcons);
      if (hydratedIcons !== null) {
        return {
          type: 'URL',
          value: hydratedIcons
        };
      }
    }
  }
  if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) {
    return {
      type: 'URL',
      value: fallbacks[fallbackKey]
    };
  }
  return null;
};